export interface facInfo {
    facFileCount: number
}

export const initialState: facInfo = {
    facFileCount: 0,
}

export const initFacInfo: facInfo = {
    facFileCount: 0,
}
